import { TableColumn } from 'react-data-table-component';
import { Identity } from '@wajeez-web/core/api-base';
import { DropDownItem } from '@wajeez-web/components/ui';
export interface ColumnsTypes extends TableColumn<any> {
  key: number;
  isHidden: boolean;
  dataType?: string;
  header: string;
  isFilterable?: boolean;
}
export interface TablefilteringOperationInput {
  property: number;
  cretiria: string;
  comparisonType: Identity.ComparisonType;
}

export interface PreferancesDatasProps {
  pageNumber: number;
  pageSize: number;
  flags: number;
  sortingOperations: Identity.SortingOperationOfInteger[];
  filteringOperations: Identity.FilteringOperationOfInteger[];
}

export const defaultTablePreferances: PreferancesDatasProps = {
  pageNumber: 0,
  pageSize: 0,
  flags: 0,
  sortingOperations: [],
  filteringOperations: [],
};
export interface FilterColumn extends SelectedColumnsFilters {
  values?: { label: string; value: string }[];
  operators: { label: string; value: string }[];

  isSelected: boolean;
  isPopular: boolean;
}

export interface SelectedColumnsFilters {
  label: string;
  key: string;
  value?: string;

  type:
    | 'Date'
    | 'String'
    | 'select'
    | 'DateTime'
    | 'Boolean'
    | 'Number'
    | 'Time'
    | 'Image'
    | 'NumberMs';
  operator: { label: string; value: string };
}

interface TableDataProps {
  currentPage: number;
  totalPages: number;
  totalCount: number;
  pageSize: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  name: string | null;
  columns: {
    value: number;
    header: string | null;
    dataType?: Identity.DataType;
    cells?: string[] | undefined;
    isHidden?: boolean;
  }[];
  defaultFilters: {
    property: number;
    comparisonType: Identity.ComparisonType;
    header: string | null;
  }[];
}

export interface TableActionType {
  title: string;
  permission: string;
  endpoint: string;
  type: 'link' | 'request' | 'dependentAction';
  action?: () => void;
  dependentActionValues?: {
    true: { label?: string; action: (id: string) => void };
    false: { label?: string; action: (id: string) => void };
  };
}
export interface TableHeaderActionType {
  type: 'action';
  onClick: () => void | Promise<void>;
  label: string;
  icon?: JSX.Element;
}
export interface Column extends SelectedColumnsFilters {
  values?: { label: string; value: string }[];
  operators: { label: string; value: string }[];

  isSelected: boolean;
  isPopular: boolean;
}

export interface TableFiltersProps {
  columns: ColumnsTypes[];
  selectedColumnsFilters: SelectedColumnsFilters[] | [];
  setSelectedColumnsFilters: (items: SelectedColumnsFilters[] | []) => void;
  tableData: Record<string, any>;
}
export interface TableProps {
  columnsSelectors?: (id: string, row: any) => { [key: number]: JSX.Element };

  tableActions?: (id: string, row: any) => TableActionType[];
  tableHeaderActions?: (columns: ColumnsTypes[]) => DropDownItem[];
  tableData: Record<string, any> | null;
  isLoading?: boolean;
  isUpdating?: boolean;
  defultFilterscomponents?: JSX.Element[];
  tableName?: string;
  PreferancesData?: PreferancesDatasProps;
  setPreferances?: (preferances: PreferancesDatasProps) => void;
}

export const ComparisonValues = [
  { label: 'Equal', value: '0' },
  { label: 'Not Equal', value: '1' },
  { label: 'Contain', value: '2' },
  { label: 'Greater', value: '3' },
  { label: 'Greater Or Equal', value: '4' },
  { label: 'Less', value: '5' },
  { label: 'Less Or Equal', value: '6' },
  { label: 'Between', value: '7' },
];

export const DateAndNumberComparisonValues = [
  { label: 'Greater', value: '3' },
  { label: 'Greater Or Equal', value: '4' },
  { label: 'Less', value: '5' },
  { label: 'Less Or Equal', value: '6' },
  { label: 'Between', value: '7' },
];

export const NumberComparisonValues = [
  { label: 'Equal', value: '0' },

  { label: 'Greater', value: '3' },
  { label: 'Greater Or Equal', value: '4' },
  { label: 'Less', value: '5' },
  { label: 'Less Or Equal', value: '6' },
  { label: 'Between', value: '7' },
];
export const StringComparisonValues = [
  { label: 'Equal', value: '0' },
  { label: 'Not Equal', value: '1' },
  { label: 'Contain', value: '2' },
];

export const OtherComparisonValues = [
  { label: 'Equal', value: '0' },
  { label: 'Not Equal', value: '1' },
];

export interface TableColumnHeaderComponentProps {
  header: string;
  dataType:
    | 'Date'
    | 'String'
    | 'select'
    | 'DateTime'
    | 'Boolean'
    | 'Number'
    | 'Time'
    | 'Image'
    | 'NumberMs';
  selectedColumnsFilters: SelectedColumnsFilters[] | [];
  setSelectedColumnsFilters: (items: SelectedColumnsFilters[] | []) => void;
  id: string;
  onSort?: (id: string, direction: Identity.OrderByDirection) => void;
  PreferancesData?: PreferancesDatasProps;
  isFilterable?: boolean;
}
